<template>
    <AppDialog v-model="isOpen" size="sm" @close="onDialogClosed">
        <template #header>
            <h2 class="text-lg font-semibold text-theme-base">
                Extender periodo
            </h2>
        </template>

        <div class="space-y-4">
            <p class="text-sm text-theme-muted">
                Corre la fecha de corte la cantidad de días que indiques. Si ya
                hay una factura pendiente o un cambio de plan programado para
                esa fecha, se corren los mismos días.
            </p>
            <custom-input
                v-model.number="form.days"
                type="number"
                label="Días a extender *"
                placeholder="Ej: 15"
                min="1"
                step="1"
                :error="error"
            />
        </div>

        <template #footer>
            <div class="flex flex-col sm:flex-row justify-end gap-2">
                <button
                    class="rounded-lg border border-theme-border px-4 py-2 text-sm font-medium text-theme-muted transition hover:bg-theme-hover"
                    @click="isOpen = false"
                >
                    Cancelar
                </button>
                <app-button color="success" :loading="loading" @click="confirm">
                    Extender
                </app-button>
            </div>
        </template>
    </AppDialog>
</template>

<script>
import AppDialog from "@/components/utils/AppDialog.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

const DEFAULT_FORM = () => ({ days: 15 });

export default {
    name: "TenantSubscriptionExtendPeriodDialog",
    components: { AppDialog, CustomInput },
    model: {
        prop: "value",
        event: "input"
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: DEFAULT_FORM(),
            error: ""
        };
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    },
    methods: {
        confirm() {
            const days = Number(this.form.days);
            if (!Number.isInteger(days) || days <= 0) {
                this.error = "Ingresa un número entero de días mayor a 0";
                return;
            }
            this.error = "";
            this.$emit("confirm", { days });
        },
        onDialogClosed() {
            this.form = DEFAULT_FORM();
            this.error = "";
        }
    }
};
</script>
